import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("dot-pagination", () => {
    it("should match the snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" max-dots="5" page="1"></ux-dot-pagination>`);
        const el = await page.find("ux-dot-pagination");
        expect(el).toHaveClass("hydrated");
        expect(el).toMatchSnapshot();
    });

    it("should emit uxPaginationChange event", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" max-dots="5" page="1"></ux-dot-pagination>`);
        const paginationChange = await page.spyOnEvent("uxPaginationChange");

        const dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");

        expect(dots[0]).toHaveClass("ux-dot-pagination__item--active");
        await dots[3].click();

        expect(paginationChange).toHaveReceivedEventDetail({ page: 4 });
        await page.waitForChanges();
        expect(dots[3]).toHaveClass("ux-dot-pagination__item--active");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-dot-pagination total="10" max-dots="5" page="5"></ux-dot-pagination>`);
    });

    it("should render with arrows", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" max-dots="5" page="1" ></ux-dot-pagination>`);
        const el = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__arrow");
        expect(el[0]).toHaveClass("ux-dot-pagination__arrow--prev");
        expect(el[0]).toHaveClass("ux-dot-pagination__arrow--disabled");

        expect(el[1]).not.toHaveClass("ux-dot-pagination__arrow--disabled");
        expect(el[1]).toHaveClass("ux-dot-pagination__arrow--next");

        expect(el).toMatchSnapshot();
    });

    it("should render without arrows", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" without-arrows="true" max-dots="5" page="1" ></ux-dot-pagination>`);
        const el = await page.find("ux-dot-pagination >>> .ux-dot-pagination__arrow");
        expect(el).toBeNull();
        expect(el).toMatchSnapshot();
    });

    it("should show the exact max dots", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" without-arrows="true" max-dots="5" page="1" ></ux-dot-pagination>`);
        const el = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item--hidden");
        expect(el).toHaveLength(5);
        expect(el).toMatchSnapshot();
    });

    it("should go to next page when clicking on Next", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" max-dots="5" page="1" ></ux-dot-pagination>`);
        let dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");
        expect(dots[0]).toHaveClass("ux-dot-pagination__item--active");

        const el = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__arrow");
        await el[1].click();
        dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");
        expect(dots[1]).toHaveClass("ux-dot-pagination__item--active");
    });

    it("should go to the previous page when clicking on Prev", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" max-dots="5" page="2" ></ux-dot-pagination>`);
        let dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");
        expect(dots[1]).toHaveClass("ux-dot-pagination__item--active");

        const el = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__arrow");
        await el[0].click();
        dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");
        expect(dots[0]).toHaveClass("ux-dot-pagination__item--active");
    });

    it("should loop", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-dot-pagination total="10" max-dots="5" page="10" loop="true"></ux-dot-pagination>`);
        let dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");
        expect(dots[9]).toHaveClass("ux-dot-pagination__item--active");

        const el = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__arrow");
        expect(el[1]).not.toHaveClass("ux-dot-pagination__arrow--disabled");
        await el[1].click();
        dots = await page.findAll("ux-dot-pagination >>> .ux-dot-pagination__item");
        expect(dots[0]).toHaveClass("ux-dot-pagination__item--active");
    });
});
